export default {
  path: 'requisites',
  name: 'requisites',
  component: () => import('../views/requisites/Requisites.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'requisites',
      linkText: 'Реквизиты'
    }
  }
}